import { Theme } from "@livechat/design-system-react-components";

import { ActionsUnion, IAction, IActionWithPayload, createAction } from "store/helper";

export enum AppActionNames {
  INIT = "FEATURES/APP/INIT",
  READY = "FEATURES/APP/READY",
  SET_INITIAL_REFERRER = "FEATURES/APP/SET_INITIAL_REFERRER",
  SET_THEME = "FEATURES/APP/SET_THEME",
}

export const AppActions = {
  init: (): IAction<AppActionNames.INIT> => createAction(AppActionNames.INIT),
  ready: (): IAction<AppActionNames.READY> => createAction(AppActionNames.READY),
  setInitialReferrer: (referrer: string): IActionWithPayload<AppActionNames.SET_INITIAL_REFERRER, string> =>
    createAction(AppActionNames.SET_INITIAL_REFERRER, referrer),
  setTheme: (theme: Theme): IActionWithPayload<AppActionNames.SET_THEME, Theme> =>
    createAction(AppActionNames.SET_THEME, theme),
};

export type AppAction = ActionsUnion<typeof AppActions>;
